import {
  getIncomeGetVersion,
  getIncomeGetOriChnl,
  getIncomeGetChnl,
  getGetAllCountry,
} from "@/api/summery";
export const selectDataList = {
  //应用
  appId: [{ label: "全部应用", value: -1 }],
  //应用版本
  appVer: [{ label: "全部应用版本", value: -1 }],
  //国家和地区
  country: [],
  //渠道
  chnl: [{ label: "全部渠道", value: -1 }],
  //原始渠道
  oriChnl: [{ label: "全部原始渠道", value: -1 }],
  //时间维度
  mainDim: [
    { label: "按天", value: 2 },
    { label: "按周", value: 3 },
    { label: "按月", value: 4 },
    { label: "自定义", value: 5 },
  ],
  // 展示维度
  subDim: [
    { label: "默认展示维度", value: -1 },
    { label: "应用", value: 3 },
    // { label: "广告位", value: 5 },
    { label: "版本号", value: 10 },
    { label: "国家和地区", value: 12 },
    { label: "原始渠道", value: 9 },
    { label: "渠道", value: 16 },
  ],
  // 隐藏列
  hiddenCol: [{ label: "默认隐藏列", value: -1 }],
};

export const baseColumnsData = [{ title: "日期", dataIndex: "resDate", sorter: true }];

export const columnsDataList = [
  { title: "展示数", dataIndex: "showCnt", sorter: true },
  { title: "日活", dataIndex: "dau", sorter: true },
  { title: "用户日均展示数", dataIndex: "showAvgDau", sorter: true },
  // 后面几项有权限控制
  { title: "收入", dataIndex: "income", sorter: true },
  { title: "收入(RMB)", dataIndex: "incomeCny", sorter: true },
  { title: "ECPM", dataIndex: "ecpm", sorter: true },
  { title: "ECPM(人民币)", dataIndex: "ecpmCny", sorter: true },
  { title: "ARPU", dataIndex: "arpu", sorter: true },
  { title: "ARPU(人民币)", dataIndex: "arpuCny", sorter: true },
];

export const textWraps = {
  style: {
    display: "block",
    width: "100%",
    wordBreak: "break-all",
    whiteSpace: "pre-wrap",
  },
};

export function getTableColumns(selectValue) {
  let tableColumns = [];
  const { subDim, mainDim } = selectValue;
  let colItem = "";
  const basicColumns = JSON.parse(JSON.stringify(baseColumnsData));
  switch (subDim.value) {
    case 3:
      colItem = { title: "应用", dataIndex: "appName", customCell: textWraps, sorter: true };
      break;
    // case 5:
    //   colItem = { title: "广告位", dataIndex: "adzName", width: 300, customCell: textWraps, sorter: true };
    //   break;
    case 10:
      colItem = { title: "版本号", dataIndex: "appVer", sorter: true };
      break;
    case 12:
      colItem = { title: "国家和地区", dataIndex: "countryName", sorter: true };
      break;
    case 9:
      colItem = { title: "原始渠道", dataIndex: "oriChnl", customCell: textWraps, sorter: true };
      break;
    case 16:
      colItem = { title: "渠道", dataIndex: "chnl", customCell: textWraps, sorter: true };
      break;
  }
  if (colItem) {
    basicColumns.push(colItem);
  }
  let colums = [];
  const isHasPermission = true;
  if (isHasPermission) {
    colums = JSON.parse(JSON.stringify(columnsDataList));
  } else {
    colums = columnsDataList.filter((item) =>
      ["resDate", "showCnt", "dau", "showAvgDau"].includes(item.dataIndex)
    );
  }
  tableColumns = basicColumns.concat(colums);
  //按天
  if (mainDim.value !== 2) {
    tableColumns = tableColumns.filter(
      (item) => !["dau", "showAvgDau", "arpu", "arpuCny"].includes(item.dataIndex)
    );
  }
  selectDataList.hiddenCol = [{ label: "默认隐藏列", value: -1 }].concat(
    tableColumns.map((item) => {
      return { label: item.title, value: item.dataIndex };
    })
  );
  return tableColumns;
}

export function getAllSelectList() {
  getGetAllCountry().then((res) => {
    selectDataList.country = selectDataList.country.concat(
      res.data.map((item) => {
        return {
          label: item.name,
          value: item.geo,
        };
      })
    );
  });
  changeAppOption();
}

export function changeAppOption(id) {
  selectDataList.appVer = [{ label: "全部应用版本", value: -1 }];
  selectDataList.chnl = [{ label: "全部渠道", value: -1 }];
  selectDataList.oriChnl = [{ label: "全部原始渠道", value: -1 }];
  const appId = id?.join(",");
  getIncomeGetVersion({ adConfId: appId }).then((res) => {
    selectDataList.appVer = selectDataList.appVer.concat(
      res.data.map((item) => {
        return {
          label: item,
          value: item,
        };
      })
    );
  });
  getIncomeGetOriChnl({ adConfId: appId }).then((res) => {
    selectDataList.oriChnl = selectDataList.oriChnl.concat(
      res.data.map((item) => {
        return {
          label: item,
          value: item,
        };
      })
    );
  });
  getIncomeGetChnl({ adConfId: appId }).then((res) => {
    selectDataList.chnl = selectDataList.chnl.concat(
      res.data.map((item) => {
        return {
          label: item,
          value: item,
        };
      })
    );
  });
}
